export const ideaConstants = {
    IDEA_LIST_REQUEST: 'IDEA_LIST_REQUEST',
    IDEA_LIST_SUCCESS: 'IDEA_LIST_SUCCESS',
    IDEA_LIST_ERROR: 'IDEA_LIST_ERROR',
    IDEA_SEARCH_REQUEST : 'IDEA_SEARCH_REQUEST',

    IDEA_ADDED_REQUEST:'IDEA_ADDED_REQUEST',
    IDEA_ADDED_SUCCESS:'IDEA_ADDED_SUCCESS',
    IDEA_ADDED_FAILURE:'IDEA_ADDED_FAILURE',  
        

    IDEA_GET_REQUEST:'IDEA_GET_REQUEST',
    IDEA_GET_SUCCESS:'IDEA_GET_SUCCESS',
    IDEA_GET_FAILURE:'IDEA_GET_FAILURE',
    
    IDEA_BY_ID_REQUEST : 'IDEA_BY_ID_REQUEST',
    IDEA_BY_ID_SUCCESS : 'IDEA_BY_ID_SUCCESS',
    IDEA_BY_ID_FAILURE : 'IDEA_BY_ID_FAILURE',

    IDEA_GET_ACTIVE_REQUEST:'IDEA_GET_ACTIVE_REQUEST',
    IDEA_GET_ACTIVE_SUCCESS:'IDEA_GET_ACTIVE_SUCCESS',
    IDEA_GET_ACTIVE_FAILURE:'IDEA_GET_ACTIVE_FAILURE',

    IDEA_DELETE_REQUEST:'IDEA_DELETE_REQUEST',
    IDEA_DELETE_SUCCESS:'IDEA_DELETE_SUCCESS',
    IDEA_DELETE_FAILURE:'IDEA_DELETE_FAILURE',
};
